// removed by extract-text-webpack-plugin
module.exports = {"doughnut-flex":"doughnut-flex___3Fsrh center___2iqBf","doughnut-flex-doughnut":"doughnut-flex-doughnut___3b2Jd center___2iqBf","doughnut-flex-content":"doughnut-flex-content___2xyAC h3___5u0xZ center___2iqBf","doughnut-flex-content-text":"doughnut-flex-content-text___1aWxH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesDoughnutChart/TargetDateSeriesDoughnutChart.css
// module id = 926
// module chunks = 0